type Props = {
  iconOrder?: number | undefined;
  href?: string;
  src: string;
  name: string;
  lockIcon?: any;
  onClick?: any;
  shareIcon?: any;
};

const SocialMedia: React.FC<Props> = ({
  iconOrder,
  href,
  src,
  name,
  lockIcon,
  onClick,
  shareIcon
}) => {
  return (
    <>
      { lockIcon && lockIcon?.[name] === "0" ? (
        <a
          className="bottom-icon social-icon-color"
          href="#"
          style={{ order: iconOrder }}
          onClick={() => alert("This is a locked icon")}
        >
          {src && <img src={src} width="25px" height="25px" alt="icon" />}
        </a>
      ) : (
        <a
          className="bottom-icon social-icon-color"
          href={href}
          style={{ order: iconOrder }}
          onClick={onClick}
        >
          {src && <img src={src} width="25px" height="25px" alt="icon" />}
        </a>
      )}
    </>
  );
};

export default SocialMedia;
